export default __webpack_public_path__ + "static/media/logo-main.a7759ed1.png";